import { render, staticRenderFns } from "./MemberTypeDetails.vue?vue&type=template&id=506ab0a4&"
import script from "./MemberTypeDetails.vue?vue&type=script&lang=js&"
export * from "./MemberTypeDetails.vue?vue&type=script&lang=js&"
import style0 from "./MemberTypeDetails.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506ab0a4')) {
      api.createRecord('506ab0a4', component.options)
    } else {
      api.reload('506ab0a4', component.options)
    }
    module.hot.accept("./MemberTypeDetails.vue?vue&type=template&id=506ab0a4&", function () {
      api.rerender('506ab0a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MemberTypeDetails.vue"
export default component.exports